import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider} from "../../nest-api";
import { responseUploadSetting } from '../dto/company-setting.dto';

@Injectable()
export class CompanySettingSf6Api {

  private readonly service: string = '';
  private readonly model: string = 'sf6s/companySetting';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public uploadSetting(uploadCode: string): Observable<responseUploadSetting> {
    const method: string = 'GET';
    const func: string = 'uploadSetting';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof uploadCode !== 'undefined' && uploadCode !== null) urlParams.uploadCode = uploadCode;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<responseUploadSetting>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/company-setting.ts